import { Component, OnInit } from '@angular/core';
import { Product } from '../../../../shared/interfaces/product';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from 'src/app/shared/services';
import { ShopService } from 'src/app/shared/services';

@Component({
    selector: 'app-page-product',
    templateUrl: './page-product.component.html',
    styleUrls: ['./page-product.component.scss']
})
export class PageProductComponent implements OnInit {

    product: Product =null;
    layout: 'standard'|'columnar'|'sidebar' = 'standard';
    sidebarPosition: 'start'|'end' = 'start'; // For LTR scripts "start" is "left" and "end" is "right"

    constructor(
        private route: ActivatedRoute,
        private seoservice:SeoService,
        private router:Router,
        private shop: ShopService,

    ) { }
    latestProducts:Product[];
    ngOnInit() {
        debugger
        //this.seoservice.updateTags(this.route.snapshot.params.productSlug,this.route.snapshot.params.productSlug)
        this.route.data.subscribe(data => {
            if(Object.keys(data.product).length==0){
                this.router.navigate(["/shop"]);
            }else{
                this.layout = data.layout || this.layout;
                this.sidebarPosition = data.sidebarPosition || this.sidebarPosition;
                this.product = data.product;
                this.seoservice.updateTags(this.product.name,this.product.descriptionshort)
            }
            
        }) 
        this.shop.getRandomProducts().subscribe((res)=>{
            this.latestProducts = res;
        });
    }
}
